import { encodeQueryParams } from '@/utils/queryParams';
import axios from 'axios';

const MAX_DOCUMENTS_LIMIT = 50;

export default {
  state: {
    documentsByStringifiedQueryParams: {},
    documentsById: {},
    // Documents fetched with ?style=summary do not contain fraud signals,
    // checks, or parsed details, so they are returned much faster from the
    // backend than ?style=advanced; sometimes even 4x faster.
    firstPageOfSummaryDocumentsByCustomerUUID: {},
  },
  actions: {
    async fetchAndCacheDocuments(context, queryParams = {}) {
      const stringifiedParams = encodeQueryParams(queryParams);
      const res = await axios.get(`/api/v2/documents?${stringifiedParams}`);

      context.state.documentsByStringifiedQueryParams[stringifiedParams] =
        res.data;

      return res.data;
    },
    async fetchAndCacheDocument(context, { customerId, documentId }) {
      const res = await axios.get(
        `/api/v2/customers/${customerId}/documents/${documentId}?style=advanced`,
      );
      context.state.documentsById[documentId] = res.data;
      return res.data;
    },
    // We fetch the first page of a customer's documents for general UI use.
    // If need be, pagination can be implemented in the future.
    async fetchAndCacheFirstPageOfSummaryDocumentsForCustomerUUID(
      context,
      customerUUID,
    ) {
      const res = await axios.get(
        `/api/v2/customers/${customerUUID}/documents?style=summary&limit=${MAX_DOCUMENTS_LIMIT}&page=1`,
      );
      const docs = res.data.data ?? [];
      context.state.firstPageOfSummaryDocumentsByCustomerUUID[customerUUID] =
        docs;
    },
  },
  getters: {
    getCachedDocuments:
      (state) =>
      (queryParams = {}) => {
        const stringifiedParams = encodeQueryParams(queryParams);
        const cached =
          state.documentsByStringifiedQueryParams[stringifiedParams];
        if (!cached) {
          return undefined;
        }
        return cached;
      },
    getCachedDocumentById: (state) => (documentId) => {
      return state.documentsById[documentId];
    },
    getCachedFirstPageOfSummaryDocumentsForCustomerUUID:
      (state) => (customerUUID) => {
        if (!customerUUID) {
          return undefined;
        }
        return state.firstPageOfSummaryDocumentsByCustomerUUID[customerUUID];
      },
  },
};
